import { apply, put } from 'redux-saga/effects';
import { Events, Categories, track } from '@app/analytics';

import ironLegacyClient from '@app/data/ironLegacyClient';
import { setErrorMsg, setSuccess } from './actions';

export function* onSubmitMultiAsk(action) {
  try {
    const data = action?.payload?.data;
    yield apply(ironLegacyClient, ironLegacyClient.postPortfolioItems, [data]);
    yield put(
      track({
        event: Events.multiAskConfirmed,
        properties: { data, category: Categories.MultiAsk },
      }),
    );
    yield put(setSuccess());
  } catch (e) {
    yield put(setErrorMsg(e));
  }
}
